/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './message.scss';
import { DialogflowQueryType } from '../../widget/models/enum';
import { getUniqueId } from '../../widget/util/commonUtil';

type propsMessageQR = {
    text: string,
    eventText ?: string,
    quickReplyHandler: any
}



const MessageQR = ({text, eventText, quickReplyHandler}: propsMessageQR) => {
    const onMessageClick = (e: any) => {
        quickReplyHandler(e, DialogflowQueryType.Text, eventText, true);
    }

    return (
        <div className='message__text--quick-reply' id={getUniqueId('qr', text)}>
            <a onClick={onMessageClick} id={getUniqueId('message', text)}>{text}</a>
        </div>
    )
}

export default MessageQR
